import { render, staticRenderFns } from "./CustomLoader.vue?vue&type=template&id=78c9dcb4&scoped=true"
import script from "./CustomLoader.vue?vue&type=script&lang=js"
export * from "./CustomLoader.vue?vue&type=script&lang=js"
import style0 from "./CustomLoader.vue?vue&type=style&index=0&id=78c9dcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9dcb4",
  null
  
)

export default component.exports